module.exports = __webpack_public_path__ + "static/media/0_2019_10_26.dade7c38.jpg";